import { usePosAuth } from '@/contexts/PosAuthContext';
import { Navigate } from 'react-router-dom';

export function ProtectedPosRoute({ children }) {
  const { posStaff, loading } = usePosAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-ink">Loading…</div>;
  if (!posStaff) return <Navigate to="/pos" replace />;
  return children;
}
